import {block} from '../utils/cn';

import './Alert.scss';

export const DEFAULT_ICON_SIZE = 18;

export const bAlert = block('alert');
